import api from "@/services/api/baseService";

class apiActionsService {
  list(type) {
    return api
      .get("/actions", {
        headers: {
          // Authorization: `Bearer ${localStorage.token}`,
        },
        params: {
          type,
        },
      })
      .then((response) => response)
      .catch((error) => error.response);
  }
}

export default new apiActionsService();
